import React, { createContext, useState, useEffect } from "react";
import { getPagesByOrganization, getOrganizationById } from "../services/OrganizationService";
import { getPlacesByUserName } from "@services/userService";

export const AuthContext = createContext(); // Asegúrate de exportar el contexto

const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(sessionStorage.getItem("token") || null);
  const [isAuthenticated, setIsAuthenticated] = useState(!!token);
  const [allowedPages, setAllowedPages] = useState([]);
  const isAdminUser = sessionStorage.getItem("isAdmin") === 'true' ? true : false;

  useEffect(() => {
    if (token) {
      setIsAuthenticated(true);
      const storedPages = sessionStorage.getItem("pages");
      if (storedPages) {
        setAllowedPages(JSON.parse(storedPages));
      }
    } else {
      setIsAuthenticated(false);
    }
  }, [token]);

  const login = async (newToken, pages = []) => {
    const id_place = newToken.places[0] ? newToken.places[0].id : null;
    const name_place = newToken.places[0] ? newToken.places[0].name_place : null;
    setToken(newToken.access_token);
    setIsAuthenticated(true);
    sessionStorage.setItem("token", newToken.access_token);
    sessionStorage.setItem("isAdmin", newToken.isAdmin);

    if (newToken.organizacion) {
      sessionStorage.setItem("organization", JSON.stringify(newToken.organizacion));
    } else if (newToken.places && newToken.places.length > 0) {
      // Si no viene la organización, pero sí las sedes, la buscamos
      try {
        const userDetails = await getPlacesByUserName();
        if (userDetails && userDetails.places && userDetails.places.length > 0) {
          const orgId = userDetails.places[0].organizacion_id;
          const organizationDetails = await getOrganizationById(orgId);
          sessionStorage.setItem("organization", JSON.stringify(organizationDetails));
        }
      } catch (error) {
        console.error("Error fetching organization details for non-admin user:", error);
        // Opcional: manejar el caso en que no se pueda obtener la organización
      }
    }

    // Asegurarse de que newToken.pages sea un array
    if (!Array.isArray(newToken.pages)) {
      newToken.pages = [];
    }
    setAllowedPages(pages);
    sessionStorage.setItem("pages", JSON.stringify(pages));
    if (id_place && name_place) {
      sessionStorage.setItem("selectedPlaceId", id_place);
      sessionStorage.setItem("selectedPlaceName", name_place);
    }
  };


  const logout = () => {
    sessionStorage.clear();
    setToken(null);
    setIsAuthenticated(false);
    setAllowedPages([]);
  };

  return (
    <AuthContext.Provider
      value={{ token, isAuthenticated, login, logout, isAdminUser, allowedPages }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
